import * as ActionTypes from './ActionTypes';

export const Audio = (state = {
    isLoading: true,
    errMess: null,
    audio: null
    },action) => {
        switch(action.type){
            case ActionTypes.DOWNLOAD_FILE:
                // console.log("asdjaksdakhsd\n\n",action.payload)
                return {...state,isLoading:false,errMess:null,audio:action.payload}
            default:
                // console.log("In Default")
                return state;
        }
    }